import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { c as o } from "../../../../clsx-OuTLNxxd.js";
import { I as v } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import { useTextarea as b } from "./textarea.hook.js";
const y = "_container_1qc3k_29", B = "_filled_1qc3k_46", C = "_error_1qc3k_49", j = "_success_1qc3k_52", I = "_counter_1qc3k_131", e = {
  container: y,
  "full-width": "_full-width_1qc3k_34",
  "group-label": "_group-label_1qc3k_37",
  filled: B,
  error: C,
  success: j,
  "helper-text": "_helper-text_1qc3k_55",
  "container-counter-icon": "_container-counter-icon_1qc3k_110",
  "container-icon": "_container-icon_1qc3k_117",
  "icon-error-warning-fill": "_icon-error-warning-fill_1qc3k_122",
  counter: I,
  "dialog-overlay-show": "_dialog-overlay-show_1qc3k_1",
  "dialog-content-show": "_dialog-content-show_1qc3k_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1qc3k_1"
};
function $({
  id: s,
  disabled: t = !1,
  status: r,
  title: l,
  helperText: i,
  placeholder: u,
  maxLength: a,
  onChange: f,
  onBlur: k,
  message: d,
  value: h,
  defaultValue: m,
  name: p,
  isFullWidth: q = !1
}) {
  const {
    valueCounter: _,
    isOnBlur: g,
    handleBlur: w,
    handleChange: N,
    hasLabelOrHelperText: x
  } = b(l, i, h, m, f, k);
  return /* @__PURE__ */ c("div", { className: o(e.container, q && e["full-width"]), children: [
    x && /* @__PURE__ */ c("div", { className: e["group-label"], children: [
      l && /* @__PURE__ */ n(
        "label",
        {
          htmlFor: s,
          className: o(r && e[r], (_ > 0 && g || t) && e.filled),
          children: l
        }
      ),
      i && /* @__PURE__ */ n("div", { className: e["helper-text"], children: i })
    ] }),
    /* @__PURE__ */ n(
      "textarea",
      {
        id: s,
        name: p,
        "aria-label": "textarea",
        placeholder: u,
        onChange: N,
        className: o(r && e[r]),
        value: h,
        defaultValue: m,
        disabled: t,
        onBlur: w
      }
    ),
    /* @__PURE__ */ c("div", { className: e["container-counter-icon"], children: [
      d && r && /* @__PURE__ */ c("div", { className: e["container-icon"], children: [
        /* @__PURE__ */ n(
          v,
          {
            name: `${r === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: o(e[r])
          }
        ),
        /* @__PURE__ */ n("span", { className: e[r], children: d })
      ] }),
      a && /* @__PURE__ */ c("div", { className: o(e.counter, _ > a && e.error), children: [
        _,
        "/",
        a
      ] })
    ] })
  ] });
}
export {
  $ as Textarea
};
